"use strict";
/**
 * CrudeTextInputTrash
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var Backspace_1 = __importDefault(require("@mui/icons-material/Backspace"));
var Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
var HighlightOff_1 = __importDefault(require("@mui/icons-material/HighlightOff"));
var DeleteForever_1 = __importDefault(require("@mui/icons-material/DeleteForever"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../../store/crude/crude.selector");
var CrudeTextInputTrash = function (props) {
    var _a, _b, _c, _d, _e;
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    return (react_1.default.createElement(material_1.InputAdornment, { onClick: function (event) { return props.onTrashClick(event); }, position: 'end' },
        react_1.default.createElement(material_1.IconButton, { "aria-label": 'delete' },
            ((_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.deleteIcon) === 'delete' &&
                react_1.default.createElement(Delete_1.default, null),
            ((_b = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _b === void 0 ? void 0 : _b.deleteIcon) === 'deleteForever' &&
                react_1.default.createElement(DeleteForever_1.default, null),
            ((_c = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _c === void 0 ? void 0 : _c.deleteIcon) === 'backspace' &&
                react_1.default.createElement(Backspace_1.default, null),
            ((_d = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _d === void 0 ? void 0 : _d.deleteIcon) === 'clear' &&
                react_1.default.createElement(Clear_1.default, null),
            ((_e = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _e === void 0 ? void 0 : _e.deleteIcon) === 'highlightOff' &&
                react_1.default.createElement(HighlightOff_1.default, null))));
};
exports.default = CrudeTextInputTrash;
